var _path, _path2, _circle, _path3, _ellipse, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.112,27.444c-2.855,0-5.086,1.434-6.724,4.296c-2.996-3.838-6.921-6.102-11.333-6.102 c-5.599,0-10.416,3.641-13.542,9.528c-5.141-6.875-13.345-11.334-22.571-11.334C18.412,23.833,5.776,36.468,5.776,52 s12.636,28.167,28.167,28.167c9.226,0,17.43-4.459,22.571-11.334c3.125,5.888,7.943,9.528,13.542,9.528 c4.412,0,8.336-2.264,11.333-6.102c1.638,2.862,3.869,4.296,6.724,4.296c6.804,0,10.111-8.032,10.111-24.556 S94.916,27.444,88.112,27.444z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M86.112,25.444c-2.855,0-5.086,1.434-6.724,4.296c-2.996-3.838-6.921-6.102-11.333-6.102 c-5.599,0-10.416,3.641-13.542,9.528c-5.141-6.875-13.345-11.334-22.571-11.334C16.412,21.833,3.776,34.468,3.776,50 s12.636,28.167,28.167,28.167c9.226,0,17.43-4.459,22.571-11.334c3.125,5.888,7.943,9.528,13.542,9.528 c4.412,0,8.336-2.264,11.333-6.102c1.638,2.862,3.869,4.296,6.724,4.296c6.804,0,10.111-8.032,10.111-24.556 S92.916,25.444,86.112,25.444z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.944,
    cy: 50,
    r: 21.667,
    fill: "#707cc0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M31.944,73.167C19.169,73.167,8.776,62.774,8.776,50s10.393-23.167,23.167-23.167 S55.111,37.226,55.111,50S44.718,73.167,31.944,73.167z M31.944,29.833c-11.121,0-20.167,9.047-20.167,20.167 s9.047,20.167,20.167,20.167S52.111,61.121,52.111,50S43.064,29.833,31.944,29.833z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.056,
    cy: 50,
    fill: "#707cc0",
    rx: 10.834,
    ry: 19.862
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M68.056,71.362c-6.916,0-12.333-9.383-12.333-21.362s5.417-21.362,12.333-21.362 S80.39,38.021,80.39,50S74.972,71.362,68.056,71.362z M68.056,31.638c-5.059,0-9.333,8.409-9.333,18.362 s4.274,18.362,9.333,18.362S77.39,59.953,77.39,50S73.115,31.638,68.056,31.638z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.112,
    cy: 50,
    fill: "#707cc0",
    rx: 3.611,
    ry: 18.056
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M86.112,69.556c-4.865,0-5.111-16.291-5.111-19.556s0.247-19.556,5.111-19.556 S91.224,46.734,91.224,50S90.977,69.556,86.112,69.556z M86.112,33.869C85.24,35.607,84.001,41.122,84.001,50 s1.239,14.393,2.111,16.131c0.873-1.738,2.111-7.253,2.111-16.131S86.985,35.607,86.112,33.869z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.cfa36c8c2892d71321b388c52cf73427.svg";
export { ForwardRef as ReactComponent };